var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDelivery2 = function SvgDelivery2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "delivery2_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#delivery2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4277FC",
    d: "M2.524 16.452a.9.9 0 0 1-.66-.27.91.91 0 0 1-.265-.668q0-.399.269-.668.27-.27.668-.27h4.363q.399 0 .668.27.27.27.27.669t-.27.668a.9.9 0 0 1-.668.269zm6.54 7.923q-1.432 0-2.435-1.003-1.005-1.003-1.004-2.434H3.978q-.52 0-.834-.391a.98.98 0 0 1-.192-.888l.341-1.332h3.513q1.179 0 1.995-.816.814-.816.814-1.997 0-.491-.172-.906a2.6 2.6 0 0 0-.472-.747H10.7q1.181 0 1.996-.816.816-.815.816-1.996 0-1.18-.816-1.997-.815-.816-1.996-.816H6.142l.284-1.063q.15-.683.672-1.115.522-.433 1.236-.433H20.96q.553 0 .892.427.339.426.207.96l-.764 3.3h1.997a2.24 2.24 0 0 1 1.808.904l2.295 3.046q.308.402.396.857.087.456.006.939l-.796 3.976a1.1 1.1 0 0 1-.396.652q-.315.252-.714.252h-1.037q0 1.43-1.002 2.433-1.003 1.004-2.433 1.004-1.433 0-2.436-1.003t-1.003-2.434H12.5q0 1.43-1.002 2.433-1.002 1.004-2.434 1.004m-4.04-12.39a.9.9 0 0 1-.668-.27.9.9 0 0 1-.27-.667q0-.4.27-.668.27-.27.668-.27h5.625q.399 0 .668.27.27.27.27.668 0 .4-.27.668a.9.9 0 0 1-.668.27zM9.062 22.5q.653 0 1.107-.456.456-.454.456-1.107 0-.651-.456-1.106a1.5 1.5 0 0 0-1.107-.456q-.651 0-1.106.456a1.5 1.5 0 0 0-.456 1.107q0 .651.456 1.106.455.456 1.106.456m12.356 0q.651 0 1.107-.456.456-.454.456-1.107 0-.651-.456-1.106a1.5 1.5 0 0 0-1.107-.456q-.651 0-1.107.456a1.5 1.5 0 0 0-.456 1.107q0 .651.456 1.106t1.107.456m-1.536-6.094h5.923l.173-.884-2.493-3.335h-2.62z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDelivery2);
export default ForwardRef;